import { useEffect, useState, useRef } from "react";
import MDBox from "components/MDBox";
import { useMaterialUIController, setIsVipUser } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import { application } from "globals/endpoints";
import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
import CTLNotification from "application/components/CTLNotification";
import DeleteConfirmation from "application/components/DeleteConfirmation";
import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
import { getUpdateColumns } from "./model/update";

function CodeBlueMaster({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller] = useMaterialUIController();
  const { activePage, tableValue } = controller;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [updateList, setUpdateList] = useState(Date.now());
  const [edit, setEdit] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openForm: onOpenForm,
        openAdvancedFilter: onOpenFilter,
      });
  }, [activePage, tableValue]);

  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onCloseFilter() {
    setOpenFilter(false);
  }

  function onApplyFilter(advancedFilters) {
    setAdvancedFilters(advancedFilters);
    setOpenFilter(false);
  }

  function onOpenForm() {
    setFormData({
      eventTime: Date.now(),
    });
    setOpenForm(true);
  }

  const deleteRow = (row) => {
    setSelectedRow(row);
    setConfirmDelete(true);
  };

  const onCancel = () => {
    setSelectedRow([]);
    setConfirmDelete(false);
  };

  const onAgree = (row) => {
    application
      .post(operationURLS.delete, {
        stringId: [row.extension],
      })
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          message: "",
          type: "success",
          pagename: pageName,
          status: response.data.messageDetail,
        });
      })
      .catch((error) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
          pagename: pageName,
          status: error.response.data.messageDetail,
        });
      });

    setConfirmDelete(false);
  };

  function onSaveForm(data) {
    if (data.id) {
      application
        .post(operationURLS.update, data)
        .then((response) => {
          setUpdateList(Date.now());
          setOpenForm(false);
          setNotify({
            isOpen: true,
            message: "",
            type: "success",
            pagename: pageName,
            status: response.data.messageDetail,
          });
          setEditForm(false);
          setEdit(false);
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
            pagename: pageName,
            status: error.response.data.messageDetail,
          });
        });
    } else {
      application
        .post(operationURLS.create, data)
        .then((response) => {
          setUpdateList(Date.now());
          setOpenForm(false);
          setNotify({
            isOpen: true,
            message: "",
            type: "success",
            pagename: pageName,
            status: response.data.messageDetail,
          });
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
            pagename: pageName,
            status: error.response.data.messageDetail,
          });
        });
    }
  }

  function onCloseForm() {
    setOpenForm(false);
  }

  const editRow = (row) => {
    setFormData(row);
    setOpenForm(false);
    setEditForm(true);
    setEdit(true);
  };

  function onCloseEditForm() {
    setEditForm(false);
  }

  function Update(){
    setUpdateList(Date.now());
  }
  return (
    <MDBox>
      <DeleteConfirmation
        entityName={pageName}
        data={selectedRow}
        columns={getColumns(deleteRow)}
        confirmDelete={confirmDelete}
        onAgree={onAgree}
        onCancel={onCancel}
      />
      <CTLBaseDialogForm
        entityName={"Add Code Blue Master"}
        columns={getColumns(deleteRow)}
        openForm={openForm}
        onSaveForm={onSaveForm}
        onCloseForm={onCloseForm}
        formData={formData}
        pageAttributes={Attributes}
      />

      {edit && (
        <CTLBaseDialogForm
          entityName={"Update Code Blue Master"}
          entityDiscription={formData.extension}
          columns={getUpdateColumns(editRow)}
          openForm={editForm}
          onSaveForm={onSaveForm}
          onCloseForm={onCloseEditForm}
          formData={formData}
          pageAttributes={Attributes}
        />
      )}

      <CTLTable
        apiURL={operationURLS.list}
        advancedFilters={advancedFilters}
        columns={getColumns(editRow, deleteRow,Update)}
        entriesPerPage={false}
        canSearch
        defaultSortDirection="desc"
        defaultSortColumn="extension"
        pageId={pageId}
        list
        searchText={searchText}
        hasRowSelection={false}
        updateList={updateList}
      />

      <CTLAdvancedFilter
        entityName={pageName}
        columns={getColumns(deleteRow)}
        applyFilter={openFilter}
        onApplyFilter={onApplyFilter}
        onCloseFilter={onCloseFilter}
        advancedFilters={advancedFilters}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default CodeBlueMaster;
